import { ResponseData } from "@/interface/request";
import instance from "@/plugins/request";

export const login = (data: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/login",
    method: "post",
    data
  });
};

// 退出方法
export const logout = (): Promise<ResponseData> => {
  return instance.request({
    url: "/logout",
    method: "post"
  });
};

export const getInfo = (): Promise<ResponseData> => {
  return instance.request({
    url: "/getInfo",
    method: "get"
  });
};

export const getRouters = (): Promise<ResponseData> => {
  return instance.request({
    url: "/getRouters",
    method: "get"
  });
};

// 获取版本信息

export const getVersion = (params: unknown): Promise<ResponseData> => {
  return instance.request({
    url: "/web/version/getVersionList",
    method: "get",
    params
  });
};
